// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--ZsUwB"};